import React from 'react';
import { Button, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useSetAtom } from 'jotai';
import ClientDrilldownDashboard from '@src/pages/main/ClientDrilldownDashboard';
import useCleanupDashboardContext from '../hooks/useCleanupDashboardContext';
import { getSessionId, isDashboardGeneratedAtom } from '../NexaStore';
import { deleteDashboard } from '@src/utils/dashboard/db';
import {
  DashboardPanelWrapper,
  DashboardHeader,
  DashboardHeaderLeft,
  DashboardHeaderRight,
  DashboardContent,
  DashboardTitle,
} from './styled';

export const DashboardWrapper: React.FC = () => {
  const cleanupDashboardContext = useCleanupDashboardContext();
  const setIsDashboardGenerated = useSetAtom(isDashboardGeneratedAtom);

  const handleClose = async () => {
    const dashboardId = getSessionId();
    if (dashboardId) {
      await deleteDashboard(dashboardId);
      cleanupDashboardContext(dashboardId);
    }
    setIsDashboardGenerated(false);
  };

  return (
    <DashboardPanelWrapper>
      <DashboardHeader>
        <DashboardHeaderLeft>
          <DashboardTitle>Generated Dashboard</DashboardTitle>
        </DashboardHeaderLeft>
        <DashboardHeaderRight>
          <Tooltip title="Close">
            <Button icon={<CloseOutlined />} onClick={handleClose} />
          </Tooltip>
        </DashboardHeaderRight>
      </DashboardHeader>
      <DashboardContent>
        <ClientDrilldownDashboard />
      </DashboardContent>
    </DashboardPanelWrapper>
  );
};

export default DashboardWrapper;
